import React, { Component } from "react";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/fonts/font-awesome.min.css";
import "../../assets/css/styles.css";
import axios from "axios";
import $ from "jquery";
import logo from "../../assets/Images/HargeisaLogo.png";

export class Headers extends Component {
  constructor(props) {
    super(props);
    const {api_url} = "http://127.0.0.1:8000/";
   

    // const url = 'hghobs.keshonect.co.ke'
    this.state = {
      logoutLoading: false
    }

    // this.handleChange = this.handleChange.bind(this);
    // this.handleSubmit = this.handleSubmit.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleLogout = (event) => {
    const url = this.api_url+"";
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
    };
    event.preventDefault();
    this.setState({
      logoutLoading: true
    });
    axios
      .post(this.api_url+"staff/logout", this.state, {
        headers: headers,
      })
      .then((response) => {
        this.setState({
          logoutLoading: false
        });
        console.log(response.data);
        if (response.data["success"] == "logged out") {
          $("#logoutSuccess").show();
          localStorage.removeItem("accessToken");
          localStorage.clear();
          // setTimeout(function (props) {
          // history.push('/reception/dashboard')
          setTimeout(function () {
            window.location.href = "/";
          }, 1000);

          // }, 2000);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  componentDidMount() {
    console.log(localStorage.getItem("accessToken"));
    $(".close").on("click", function () {
      $(".modal").hide();
    });
    if (localStorage.getItem("accessToken") == null) {
      $(".loginFirst").show();
      setTimeout(function () {
        window.location.href = "/";
      }, 1000);
    }
  }

  render() {
    const displayHidden = { display: "none" };
    const logoDimensions = { height: "50px", innerWidth: "180px" };
    const { logoutLoading} = this.state;
    return (
      <div>
        <meta name="viewport" content="initial-scale=1, width=device-width" />

        <header>
          <nav className="navbar navbari-light navbar-expand-md background-blue navbar-fixed-top">
            <div className="container-fluid">
              <a className="navbar-brand" href="/home">
                <img src={logo} style={logoDimensions} />
              </a>
              <button
                data-toggle="collapse"
                className="navbar-toggler"
                data-target="#navcol-1"
              >
                {/* <span className="sr-only">Toggle navigation</span> */}
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse justify-content-center"
                id="navcol-1"
              >
                <ul className="navbar-nav justify-content-center">
                  {/* <li className="nav-item"><a className="nav-link active font-weight-bold text-capitalize" >Staff Registration</a></li> */}
                  <li className="nav-item"><p style={{color:"white"}}>Current User Logged In: {localStorage.getItem("Currentusername")}</p></li><br/>
                  {localStorage.getItem("currentModule") ?<p style={{color:"white"}}>|| Current Module: { localStorage.getItem("currentModule")}</p>: <p></p>}
                </ul>
              </div>
              <button className="btn btn-primary" onClick={this.handleLogout}>
              {logoutLoading ? 'Loading' : 'Logout'} 
              </button>
            </div>
          </nav>
          <div className="modal loginFirst" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title PatientName"></h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <strong>Success! </strong>Please Login First to Access this
                  Page
                </div>
                <div className="modal-footer"></div>
              </div>
            </div>
          </div>
          <div className="modal" id="logoutSuccess" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title PatientName"></h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <strong>Success! </strong>Logout Successful.
                </div>
                <div className="modal-footer"></div>
              </div>
            </div>
          </div>
        </header>
      </div>
    );
  }
}

export default Headers;
